module.exports = __webpack_public_path__ + "media/images/lp-flow-step-2@2x-58a9f0ab94177359c76d87584aea7e20.png";